import useAuth from '@contexts/AuthProvider';
import { Stack, Typography } from '@mui/material';
import { useRequireAuthentication } from '@pages/RegisterPage/hooks/useRequireAuthentication';
import { Trans } from 'react-i18next';
import { Outlet } from 'react-router';

export const AuthenticationWrapper: React.FC = () => {
  const { authenticated } = useAuth();
  useRequireAuthentication();

  if (!authenticated) {
    return (
      <Stack sx={{ gap: 1, textAlign: 'center' }}>
        <Typography variant="h5">
          <Trans i18nKey="auth.title" />
        </Typography>
        <Typography>
          <Trans i18nKey="auth.message" />
        </Typography>
      </Stack>
    );
  }

  return <Outlet />;
};
